import React from "react";
import Overview from "./Overview";
import AppWithAuth from "./AppWithAuth";
import AddMoney from "./Payments/AddMoney"
import { BrowserRouter as Router, Route } from "react-router-dom";
import params from "./Params";
import Payment from "./Payments/Payment";
import PaymentStatus from "./Payments/PaymentStatus";
import OrdersList from "./Payments/OrdersList";
import withUserData from "./Utils/withUserData";
import PartnerPortal from "./Partners/PartnerPortal";
import PartnerAccountEditor from "./Partners/PartnerAccountEditor";
import PartnerTransactions from "./Partners/PartnerTransactions";
import PartnerAgreements from "./Partners/PartnerAgreements";
import PartnersList from "./Admin/PartnersList";
import AdminPortal from "./Admin/AdminPortal";
import AgreementsList from "./Admin/AgreementsList";
import ManufacturerPortal from "./Manufacturer/ManufacturerPortal";
import withSimGpsHwController from "./Utils/withSimGpsHwController";

const LOCAL_SERVER = 'http://localhost:12346';


// Wrap the components that require authentication with withUserData HOC
const AppWithUserData = withUserData(AppWithAuth);
const AddMoneyWithUserData = withUserData(AddMoney);
const PaymentWithUserData = withUserData(Payment);
const PaymentStatusWithUserData = withUserData(PaymentStatus);
const OrdersListWithUserData = withUserData(OrdersList);
const PartnerPortalWithUserData = withUserData(PartnerPortal);
const PartnerAccountEditorWithUserData = withUserData(PartnerAccountEditor);
const PartnerTransactionsWithUserData = withUserData(PartnerTransactions);
const PartnerAgreementsWithUserData = withUserData(PartnerAgreements);
const AdminPortalWithUserData = withUserData(AdminPortal);
const PartnersListWithUserData = withUserData(PartnersList);
const AgreementsListWithUserData = withUserData(AgreementsList);
const ManufacturerPortalWithUserData = withUserData(withSimGpsHwController(ManufacturerPortal));


class Root extends React.Component {

    constructor(props) {
        super(props);

        const useLocalIfServer = true;

        let urls =  {
            sim_init: params.SIM_INIT_URL,
            sim_update: params.SIM_UPDATE_URL,
            dut_ctrl: LOCAL_SERVER + '/dut_ctrl',
        };

        if (useLocalIfServer) {
            urls={
                sim_init : LOCAL_SERVER + '/sim_init.json',
                sim_update : LOCAL_SERVER + '/Test/sim_data',
                dut_ctrl : LOCAL_SERVER + '/dut_ctrl',
            };
        }

        this.state = {
            urls: urls
        };
    }

    render() {
        return (
            <Router>
                <div>
                    <Route path="/" exact component={Overview} />

                    <Route path="/devices" exact
                           render={(props) => <AppWithUserData {...props}
                                                           urls={this.state.urls}
                                                           onSetDevices={this.setDevices}
                                                           devices={this.state.devices}
                           />}
                    />

                    <Route path="/addmoney/:dev_uuid"
                           render={({ match }) =>
                                       <AddMoneyWithUserData
                                           dev_uuid={match.params.dev_uuid}
                                       />}
                    />

                    <Route path="/payment/:payment_metod/:dev_uuid/:amount"
                           render={({ match }) => {
                               return (
                                   <PaymentWithUserData
                                       payment_metod={match.params.payment_metod}
                                       dev_uuid={match.params.dev_uuid}
                                       amount={match.params.amount}
                                   />
                                   );
                             }
                           }
                    />

                    <Route path="/payment_status" exact
                           render={(props) => <PaymentStatusWithUserData {...props} />} />

                    <Route path="/orders" exact
                           render={(props) => <OrdersListWithUserData {...props} />} />

                    <Route path="/partner" exact
                           render={ (props) => ( <PartnerPortalWithUserData {...props} /> ) } />

                    <Route path="/partner/stripe_account" exact
                           render={ (props) => ( <PartnerAccountEditorWithUserData {...props} /> ) } />

                    <Route path="/partner/transactions" exact
                           render={ (props) => ( <PartnerTransactionsWithUserData {...props} /> ) } />

                    <Route path="/partner/agreements" exact
                           render={ (props) => ( <PartnerAgreementsWithUserData {...props} /> ) } />

                    <Route path="/admin/partners" exact
                           render={ (props) => ( <PartnersListWithUserData {...props} /> ) } />

                    <Route path="/admin/agreements" exact
                           render={ (props) => ( <AgreementsListWithUserData {...props} /> ) } />

                    <Route path="/admin" exact
                           render={ (props) => ( <AdminPortalWithUserData {...props} /> ) } />

                    <Route path="/manufacturer" exact
                           render={ (props) => ( <ManufacturerPortalWithUserData {...props} /> ) } />

                </div>
            </Router>
        );
    }
}

export default Root;
